import { render, staticRenderFns } from "./Facet.vue?vue&type=template&id=91eca53a&"
import script from "./Facet.vue?vue&type=script&lang=js&"
export * from "./Facet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports